import { render } from "./ListeMagasinPage.vue?vue&type=template&id=2636f659&ts=true"
import script from "./ListeMagasinPage.vue?vue&type=script&lang=ts"
export * from "./ListeMagasinPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__